import React from 'react';
import SEO from './SEO';

const RouteWithSEO = ({ 
    children, 
    titleRu, 
    titleEn, 
    descriptionRu, 
    descriptionEn, 
    noindex = false,
    canonical,
    image 
}) => {
    return (
        <>
            <SEO 
                titleRu={titleRu}
                titleEn={titleEn}
                descriptionRu={descriptionRu}
                descriptionEn={descriptionEn}
                noindex={noindex}
                canonical={canonical}
                image={image}
            />
            {children}
        </>
    );
};

export default RouteWithSEO;
